import { motion } from "framer-motion";

const SERVICES = [
  {
    code: "A",
    title: "Architecture & Planning",
    items: ["Conceptual & Schematic Design", "Detailed Design Development", "Interior & Exterior Planning", "Compliance & Approvals"],
    span: "md:col-span-7",
  },
  {
    code: "B",
    title: "Structural Engineering",
    items: ["Analysis & Design — Concrete, Steel, Timber, Hybrid", "Foundation & Substructure", "Retrofitting & Rehabilitation", "Value Engineering"],
    span: "md:col-span-5",
  },
  {
    code: "C",
    title: "MEP Engineering",
    items: ["HVAC Systems", "Electrical & Lighting", "Plumbing & PHE", "Energy & Efficiency"],
    span: "md:col-span-5",
  },
  {
    code: "D",
    title: "BIM Design & Technical Services",
    items: ["Design-to-BIM — 2D CAD to 3D BIM, LOD 100–500", "Scan-to-BIM — Point Clouds to As-Built", "Clash Detection & Coordination", "4D & 5D BIM, COBie & FM Integration"],
    span: "md:col-span-7",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 lg:py-36 border-b border-white/10" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono-tech text-xs tracking-[0.35em] uppercase text-neutral-500 mb-4"
        >
          01 / Services
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-heading font-bold uppercase tracking-tighter text-3xl sm:text-4xl lg:text-5xl mb-16 max-w-2xl"
        >
          One studio. Every discipline.
        </motion.h2>

        <div className="grid md:grid-cols-12 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.code}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`group bg-black hover:bg-white transition-colors duration-500 p-8 lg:p-10 ${s.span}`}
              data-testid={`service-card-${s.code.toLowerCase()}`}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-heading font-black text-4xl text-white/15 group-hover:text-black/15 transition-colors duration-500">
                  {s.code}
                </span>
                <span className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-600 group-hover:text-neutral-500 transition-colors duration-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-heading font-bold uppercase tracking-tight text-xl mb-6 group-hover:text-black transition-colors duration-500">
                {s.title}
              </h3>
              <ul className="space-y-2.5">
                {s.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-sm text-neutral-400 font-light group-hover:text-neutral-700 transition-colors duration-500"
                  >
                    <span className="w-4 h-px bg-white/30 group-hover:bg-black/30 transition-colors duration-500" />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
